import { clsx } from "clsx";
import styles from "./index.module.css";
import { FieldError } from "react-hook-form";

interface Props {
  placeholder?: string;
  error?: FieldError;
  name: string;
  type: string;
  register?: any;
  value?: string;
  defaultValue?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const CustomInput = (props: Props) => {
  const {
    placeholder,
    name,
    type,
    register,
    error,
    value,
    defaultValue,
    onChange,
  } = props;

  const {
    ref,
    onChange: rhfOnChange,
    onBlur,
    name: fieldName,
  } = register(name);

  return (
    <div className={"flex flex-col items-center justify-center"}>
      <input
        name={fieldName}
        ref={ref}
        onBlur={onBlur}
        onChange={(e) => {
          rhfOnChange(e);
          onChange?.(e);
        }}
        className={clsx(
          error ? styles.invalid : styles.input,
          `w-full px-4 outline-none h-[42px] font-raleway text-lg bg-white rounded`
        )}
        defaultValue={defaultValue}
        placeholder={placeholder}
        type={type}
        value={value}
        autoComplete="off"
      />
      {error && (
        <span className="text-red-500 text-sm w-[100%] mt-1 font-bold flex items-start justify-start capitalize">
          {error.message}
        </span>
      )}
    </div>
  );
};

export default CustomInput;
